import React, { useEffect, useState } from "react";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import { message, Spin, DatePicker, Row, Col, Pagination, Select } from "antd";
import { TitleSearch } from "components/SearchWidget/TitleSearch";
import TableWidget from "./TableWidget/TableWidget";
import { showBuyerDetailDialog } from "./BuyerDetailDialog/showBuyerDetailDialog";
import {
  apiGetBuyerApplicationList,
  apiSuspendBuyer,
  apiReactivateBuyer,
  apiGetPriceTierList,
} from "services/shopBuyerService";
const { RangePicker } = DatePicker;

const STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "suspended", label: "Suspended" },
];

function ShopBuyerListPage() {
  const [isBusy, setIsBusy] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [searchText, setSearchText] = useState("");
  const [priceTiers, setPriceTiers] = useState([]);

  const loadBuyers = () => {
    setIsBusy(true);
    apiGetBuyerApplicationList(currentPage, pageSize, startDate, endDate, statusFilter, searchText)
      .then((data) => {
        setIsBusy(false);
        setDataList(data.dataList);
        setSearchList(data.dataList);
        setTotalCount(data.total_count);
      })
      .catch((err) => {
        setIsBusy(false);
        setDataList([]);
        setSearchList([]);
        message.error("Sorry! " + err);
      });
  };

  useEffect(() => {
    loadBuyers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, currentPage, startDate, endDate, statusFilter, searchText]);

  useEffect(() => {
    apiGetPriceTierList()
      .then((list) => setPriceTiers(list || []))
      .catch(() => setPriceTiers([]));
  }, []);

  const onShowSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(current);
  };
  const onChange = (pageNumber) => setCurrentPage(pageNumber);

  const handleSearch = (text) => {
    setCurrentPage(1);
    setSearchText(text || "");
  };
  const handleChange = (event) => {
    if (event.target.value === "") handleSearch("");
  };

  const handleDateFilter = (start, end) => {
    setCurrentPage(1);
    setStartDate(start);
    setEndDate(end);
  };

  const onClickView = async (pInfo) => {
    const res = await showBuyerDetailDialog({ buyer: pInfo, priceTiers });
    if (res) {
      const patch = (list) => list.map((x) => (x.id == pInfo.id ? { ...x, ...res } : x));
      setDataList(patch(dataList));
      setSearchList(patch(searchList));
    }
  };

  const onSuspend = (pInfo) => {
    setIsBusy(true);
    apiSuspendBuyer(pInfo.id)
      .then((data) => {
        setIsBusy(false);
        const patch = (list) => list.map((x) => (x.id == pInfo.id ? { ...x, ...data } : x));
        setDataList(patch(dataList));
        setSearchList(patch(searchList));
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const onReactivate = (pInfo) => {
    setIsBusy(true);
    apiReactivateBuyer(pInfo.id)
      .then((data) => {
        setIsBusy(false);
        const patch = (list) => list.map((x) => (x.id == pInfo.id ? { ...x, ...data } : x));
        setDataList(patch(dataList));
        setSearchList(patch(searchList));
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <h1>Wholesale Applications</h1>
        <Row align="middle">
          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              Date Filter Period : &nbsp;&nbsp;
              <RangePicker
                size={"default"}
                onChange={(e, date) => {
                  if (date == null) handleDateFilter("", "");
                  else handleDateFilter(date[0], date[1]);
                }}
              />
            </div>
          </Col>
          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <Select
                style={{ width: 180 }}
                value={statusFilter}
                onChange={(v) => {
                  setCurrentPage(1);
                  setStatusFilter(v);
                }}
                options={STATUS_OPTIONS}
              />
            </div>
          </Col>
          <Col flex={"auto"}>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <TitleSearch onSearch={handleSearch} onChange={handleChange} />
            </div>
          </Col>
        </Row>
        <Row justify={"center"} style={{ paddingTop: 16 }}>
          <Col>
            <Pagination
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              onChange={onChange}
              defaultCurrent={1}
              current={currentPage}
              total={totalCount}
              pageSize={pageSize}
            />
          </Col>
        </Row>

        <div style={{ paddingTop: 32 }}>
          <TableWidget
            dataList={searchList}
            onViewAction={onClickView}
            onSuspendAction={onSuspend}
            onReactivateAction={onReactivate}
          />
        </div>
      </Spin>
    </CommonDivWidget>
  );
}

export default ShopBuyerListPage;
